<template>
  <div class="sal-page">
    <div class="sal-card">
      <div class="sal-card__header">
        <h1 class="sal-title">重設密碼</h1>
        <p class="sal-subtitle">請輸入新密碼（至少 6 碼）</p>
      </div>

      <div v-if="done" class="sal-success">
        <p>✅ 密碼已更新，請使用新密碼登入。</p>
        <router-link :to="{ name: 'StoreAdminLogin' }" class="sal-back-link">前往登入 →</router-link>
      </div>

      <form v-else class="sal-form" @submit.prevent="onSubmit">
        <div class="sal-field">
          <label for="rp-password">新密碼</label>
          <div class="sal-password-wrap">
            <input
              id="rp-password"
              v-model="password"
              :type="showPw ? 'text' : 'password'"
              placeholder="請輸入新密碼（至少 6 碼）"
              class="sal-input"
              autocomplete="new-password"
            />
            <button type="button" class="sal-toggle" @click="showPw = !showPw">
              {{ showPw ? '隱藏' : '顯示' }}
            </button>
          </div>
          <p v-if="pwError" class="sal-field-error">{{ pwError }}</p>
        </div>

        <div v-if="apiError" class="sal-api-error">{{ apiError }}</div>

        <button type="submit" class="sal-submit" :disabled="submitting">
          <span v-if="submitting" class="sal-spinner" />
          {{ submitting ? '更新中…' : '確認重設密碼' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'

const route      = useRoute()
const password   = ref('')
const pwError    = ref('')
const apiError   = ref('')
const submitting = ref(false)
const done       = ref(false)
const showPw     = ref(false)
const token      = ref('')

onMounted(() => {
  token.value = route.query.token || ''
  if (!token.value) apiError.value = '連結無效，請重新申請忘記密碼。'
})

async function onSubmit() {
  pwError.value  = ''
  apiError.value = ''
  if (password.value.length < 6) { pwError.value = '密碼至少 6 碼'; return }
  submitting.value = true
  try {
    await axios.post('/api/store-admin/reset-password', {
      token: token.value,
      password: password.value,
    })
    done.value = true
  } catch (e) {
    apiError.value = e.response?.data?.message || '發生錯誤，請稍後再試'
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.sal-page {
  min-height: 100vh; display: flex; align-items: center;
  justify-content: center; background: #f4f6f9; padding: 24px 16px;
}
.sal-card {
  background: #fff; border-radius: 14px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 40px 36px; width: 100%; max-width: 420px;
}
.sal-card__header { text-align: center; margin-bottom: 32px; }
.sal-title { font-size: 1.5rem; color: #2c3e50; margin: 0 0 8px; }
.sal-subtitle { font-size: 0.88rem; color: #95a5a6; margin: 0; }
.sal-form { display: flex; flex-direction: column; gap: 20px; }
.sal-field { display: flex; flex-direction: column; gap: 6px; }
.sal-field label { font-size: 0.88rem; color: #555; font-weight: 500; }
.sal-password-wrap { position: relative; display: flex; align-items: center; }
.sal-input {
  width: 100%; padding: 11px 14px; border: 1px solid #dce1e7;
  border-radius: 8px; font-size: 1rem; background: #fff;
  box-sizing: border-box; transition: border-color 0.15s; -webkit-appearance: none;
  padding-right: 60px;
}
.sal-input:focus { outline: none; border-color: #2c3e50; box-shadow: 0 0 0 3px rgba(44,62,80,0.08); }
.sal-toggle {
  position: absolute; right: 12px; background: none; border: none;
  font-size: 0.8rem; color: #95a5a6; cursor: pointer; padding: 0;
}
.sal-toggle:hover { color: #555; }
.sal-field-error { font-size: 0.8rem; color: #e74c3c; margin: 0; }
.sal-api-error {
  background: #fdedec; border: 1px solid #f5b7b1; border-radius: 8px;
  padding: 12px 14px; font-size: 0.88rem; color: #c0392b; line-height: 1.5;
}
.sal-submit {
  display: flex; align-items: center; justify-content: center; gap: 8px;
  width: 100%; padding: 13px; background: #2c3e50; color: #fff;
  border: none; border-radius: 8px; font-size: 1rem; font-weight: 600;
  cursor: pointer; transition: background 0.15s;
}
.sal-submit:hover:not(:disabled) { background: #34495e; }
.sal-submit:disabled { opacity: 0.6; cursor: not-allowed; }
.sal-spinner {
  display: inline-block; width: 18px; height: 18px;
  border: 2px solid rgba(255,255,255,0.35); border-top-color: #fff;
  border-radius: 50%; animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
.sal-success { text-align: center; color: #27ae60; font-size: 0.95rem; line-height: 1.7; }
.sal-back-link {
  color: #2c3e50; text-decoration: none; display: inline-block;
  margin-top: 12px; font-size: 0.9rem; font-weight: 600;
}
.sal-back-link:hover { text-decoration: underline; }
@media (max-width: 480px) { .sal-card { padding: 28px 20px; } }
</style>
